import fetchSession from '../../fetchSession.js'
const environment = process.env.NODE_ENV || process.env.ENVIRONMENT || 'staging'
const config = {
  'development': {
    apiURL: 'https://staging.components.americanrepertorytheater.org/'
  },
  'staging': {
    apiURL: 'https://staging.components.americanrepertorytheater.org/'
  },
  'production': {
    apiURL: 'https://components.americanrepertorytheater.org/'
  }
}
/**
 * Pre cart survey update
 *
 * Components:
 * + survey component
 */

// Page URL
const pageURL = window.location.href

async function session () {
  try {
    const session = await fetchSession()

    // check we are on the cart/details page and check we have a logged in user in the session
    // If we are on the cart/details page and the user is logged in,
    // then add a url parameter to the checkout button ?precart=true if the user has no demographic asked attriubte assigned to them.
    // This will send to the payment page with the precart parameter set to true if no demographic asked attribute is assigned their record
    // as the precart payment parameter is present display the survey with the submission sent the payment page

    // Cart details page
    if (pageURL.includes('cart/details')) {
      // check if something is already in the cart by looking for the cart timer element
      const timerElement = document.querySelector('.tn-utility-nav-cart-timer')
      if (timerElement && timerElement.offsetParent !== null) {
        // User has something in their cart, check if they have the demographic asked attribute
        const checkoutButton = document.querySelector('a.tn-cart-buttons__primary-action')
        if (session && session.customer.id > 0) {
          const apiBaseURL = config[environment].apiURL
          const response = fetch(`${apiBaseURL}api/demographic-asked/${session.customer.id}`)
          const demographicAsked = await response.then(res => res.json())
            .then(data => data.check).catch(err => console.error(err))

          if (!demographicAsked) {
            // User does not have the demographic asked attribute, so add the precart parameter to the checkout button
            if (checkoutButton) {
              const url = new URL(checkoutButton.getAttribute('href'), window.location.origin)
              url.searchParams.set('precart', 'true')
              console.log('Updated checkout button URL:', url.toString())
              checkoutButton.setAttribute('href', url.toString())
            }
          }
        } else {
          console.log('Change to target to cart details page so that the returnurl will come back here')
          const url = new URL('/account/login', window.location.origin)
          url.searchParams.set('returnurl', '/cart/details')
          checkoutButton.setAttribute('href', url.toString())
        }
      }
    }

    // Cart payment page
    if (pageURL.includes('cart/payment') && session && session.customer.id > 0) {
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('precart')) {
        const main = document.querySelector('main.tn-payment-page')
        const header = main.querySelector('.tn-header-component')
        if (pageURL.includes('/cart/payment') && window.location.search.includes('precart=true')) {
          document.title = 'Survey | A.R.T. - American Repertory Theater'
        }
        // Update the page heading
        const heading = header.querySelector('#tn-page-heading')
        if (heading) {
          heading.textContent = 'Survey'
        }
        // Remove the existing content below the header
        let node = header.nextElementSibling
        while (node) {
          const next = node.nextElementSibling
          node.remove()
          node = next
        }

        // Create a new div for the survey info
        const surveyInfo = document.createElement('div')
        surveyInfo.className = 'tn-survey-info'
        surveyInfo.innerHTML = `
      <p>In order to see how well we’re serving the widest possible audience, we would like to learn more about you. All the questions below are optional—you may answer several, one, or none.</p>
      <p>If you have any questions about this survey, please email us at Contact@amrep.org.</p>
    `
        const surveyComponent = document.createElement('american-rep-survey')
        surveyComponent.setAttribute('session-key', session.key)

        // Append to <main> after header
        main.appendChild(surveyInfo)
        main.appendChild(surveyComponent)

        surveyComponent.addEventListener('survey-submitted', () => {
          // Redirect to the payment page after survey submission for the client to complete the order
          window.location.href = `${window.location.origin}/cart/payment`
        })
      }
    }
  } catch (error) {
    console.error('Error fetching session from datqlayer:', error)
    // If there is an error fetching the session, redirect to the payment page to ensure the user can complete their order
    window.location.href = `${window.location.origin}/cart/payment`
  }
}
// Initialize session
session().then(() => {
  // Session fetched successfully
}).catch(error => {
  console.error('Error initializing session:', error)
})
